<template>
  <div class="tab-switch tab-switch--vertical" v-show="show">
    <div
      v-for="tabItem in items"
      :key="tabItem[keyField]"
      :class="['tab-switch__item', { active: isActive(tabItem) }]"
      @click="handleClick(tabItem)"
    >
      {{ tabItem[labelField] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "VerticalTabSwitch",
  props: {
    modelValue: {
      type: [Object, String, Number],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: false,
    },
    keyField: {
      type: String,
      default: "key",
    },
    labelField: {
      type: String,
      default: "name",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    currentActive() {
      return this.modelValue;
    },
  },
  methods: {
    isActive(tabItem) {
      const activeItem = this.currentActive;
      if (!activeItem) return false;
      if (typeof activeItem === "object") {
        return (
          activeItem === tabItem ||
          activeItem[this.keyField] === tabItem[this.keyField]
        );
      }
      return activeItem === tabItem[this.keyField];
    },
    handleClick(tabItem) {
      if (this.isActive(tabItem)) {
        return;
      }
      this.$emit("update:modelValue", tabItem);
    },
  },
};
</script>

<style scoped lang="scss">
.tab-switch {
  &--vertical {
    display: flex;
    flex-direction: column;
    border-right: 1px solid #e6e6e6;
    min-width: 180px;
    padding-top: 8px;
  }

  &__item {
    cursor: pointer;
    padding: 12px 16px;
    color: #666;
    position: relative;
    font-size: 14px;
    flex-shrink: 0;
    text-align: left;

    &.active {
      color: #28b8c3;
      font-weight: 600;
      background: #eaf8f9;
      border-right: 2px solid #28b8c3;
      margin-right: -1px;
    }
  }
}
</style>
